<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <el-form :model="query" inline>
        <el-form-item label="分类名称">
          <el-input
            v-model="query.categoryName"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card>
      <div style="margin-bottom: 15px">
        <el-button type="primary" @click="handleAdd">新增分类</el-button>
      </div>
      <el-table :data="treeData" border stripe v-loading="loading" row-key="id" :tree-props="{children: 'children'}" default-expand-all>
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="categoryName" label="分类名称"></el-table-column>
        <el-table-column label="图标" width="80">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.iconUrl"
              :src="row.iconUrl"
              style="width: 40px; height: 40px"
              fit="cover"
            ></el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="{ row }">
            <el-tag
              :type="row.enabled === 1 ? 'success' : 'info'"
              size="small"
              >{{ row.enabled === 1 ? "启用" : "禁用" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="首页展示" width="90">
          <template slot-scope="{ row }">
            <el-tag
              :type="row.showOnHome === 1 ? 'warning' : 'info'"
              size="small"
              >{{ row.showOnHome === 1 ? "展示" : "不展示" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="sortOrder"
          label="排序"
          width="80"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="160"
        ></el-table-column>
        <el-table-column label="操作" width="280">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" @click="handleFields(row)"
              >字段管理</el-button
            >
            <el-button
              type="text"
              style="color: #f56c6c"
              @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog
      :title="isEdit ? '编辑分类' : '新增分类'"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="分类名称" prop="categoryName">
          <el-input v-model="form.categoryName"></el-input>
        </el-form-item>
        <el-form-item label="分类图标">
          <div style="display: flex; align-items: flex-start; gap: 12px">
            <el-upload
              class="category-icon-upload"
              :action="uploadAction"
              :headers="uploadHeaders"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              accept="image/*"
              style="display: inline-block"
            >
              <el-button size="small" type="primary" :loading="uploading"
                >选择图标</el-button
              >
              <div
                slot="tip"
                style="font-size: 12px; color: #909399; margin-top: 4px"
              >
                建议尺寸 80x80，支持 jpg/png
              </div>
            </el-upload>
            <div v-if="form.iconUrl" class="icon-preview">
              <el-image
                :src="form.iconUrl"
                style="width: 40px; height: 40px"
                fit="cover"
              ></el-image>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="父级分类">
          <el-select
            v-model="form.parentId"
            placeholder="请选择（可选）"
            clearable
            style="width: 100%"
          >
            <el-option
              v-for="c in list"
              :key="c.id"
              :label="c.categoryName"
              :value="c.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortOrder" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch
            v-model="form.enabled"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          ></el-switch>
        </el-form-item>
        <el-form-item label="首页展示">
          <el-switch
            v-model="form.showOnHome"
            :active-value="1"
            :inactive-value="0"
            active-text="展示"
            inactive-text="不展示"
          ></el-switch>
          <span style="font-size: 12px; color: #909399; margin-left: 10px">最多7个分类可展示在首页</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 字段管理弹窗 -->
    <el-dialog title="字段管理" :visible.sync="fieldVisible" width="900px">
      <div style="margin-bottom: 10px">
        <el-button type="primary" size="small" @click="handleAddField"
          >新增字段</el-button
        >
      </div>
      <el-table :data="fields" border size="small" style="width: 100%">
        <el-table-column
          prop="fieldName"
          label="字段名称"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="fieldKey"
          label="字段Key"
          width="120"
        ></el-table-column>
        <el-table-column
          prop="fieldType"
          label="类型"
          width="100"
        ></el-table-column>
        <el-table-column label="必填" width="70">
          <template slot-scope="{ row }">
            <el-tag :type="row.requiredFlag ? 'danger' : 'info'" size="small">{{
            row.requiredFlag ? "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="筛选" width="70">
          <template slot-scope="{ row }">
            <el-tag :type="row.filterFlag ? 'success' : 'info'" size="small">{{
              row.filterFlag ? "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="列表" width="70">
          <template slot-scope="{ row }">
            <el-tag :type="row.listShowFlag ? 'success' : 'info'" size="small">{{
              row.listShowFlag ? "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="详情" width="70">
          <template slot-scope="{ row }">
            <el-tag :type="row.detailShowFlag ? 'success' : 'info'" size="small">{{
              row.detailShowFlag ? "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="AI" width="70">
          <template slot-scope="{ row }">
            <el-tag :type="row.aiFieldFlag ? 'success' : 'info'" size="small">{{
              row.aiFieldFlag ? "是" : "否"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="sortOrder" label="排序" width="70"></el-table-column>
        <el-table-column label="状态" width="70">
          <template slot-scope="{ row }">
            <el-tag :type="row.enabled === 1 ? 'success' : 'info'" size="small">{{
              row.enabled === 1 ? "启用" : "禁用"
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="{ row: f }">
            <el-button type="text" @click="handleEditField(f)">编辑</el-button>
            <el-button
              type="text"
              style="color: #f56c6c"
              @click="handleDeleteField(f)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 字段编辑弹窗 -->
    <el-dialog
      :title="fieldIsEdit ? '编辑字段' : '新增字段'"
      :visible.sync="fieldDialogVisible"
      width="860px"
    >
      <el-form ref="fieldFormRef" :model="fieldForm" :rules="fieldRules" label-width="110px">
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="字段名称" prop="fieldName">
              <el-input v-model="fieldForm.fieldName" placeholder="如：价格"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="字段Key" prop="fieldKey">
              <el-input v-model="fieldForm.fieldKey" placeholder="如：price"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="字段类型" prop="fieldType">
              <el-select v-model="fieldForm.fieldType" placeholder="请选择" style="width: 100%">
                <el-option
                  v-for="item in fieldTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="排序" prop="sortOrder">
              <el-input-number v-model="fieldForm.sortOrder" :min="0" style="width: 100%"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="12">
            <el-form-item label="占位提示">
              <el-input v-model="fieldForm.placeholder" placeholder="如：请输入价格"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="默认值">
              <el-input v-model="fieldForm.defaultValue" placeholder="可选"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="选项JSON">
          <el-input
            v-model="fieldForm.optionsJson"
            type="textarea"
            :rows="3"
            placeholder='仅在选择类字段使用，例如 [{"label":"A","value":"A"}]'
          ></el-input>
        </el-form-item>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="必填">
              <el-switch
                v-model="fieldForm.requiredFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="筛选">
              <el-switch
                v-model="fieldForm.filterFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="AI识别">
              <el-switch
                v-model="fieldForm.aiFieldFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="8">
            <el-form-item label="列表展示">
              <el-switch
                v-model="fieldForm.listShowFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="详情展示">
              <el-switch
                v-model="fieldForm.detailShowFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="启用状态">
              <el-switch
                v-model="fieldForm.enabled"
                :active-value="1"
                :inactive-value="0"
                active-text="启用"
                inactive-text="禁用"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="fieldDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmitField">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getCategories,
  addCategory,
  updateCategory,
  deleteCategory,
  getCategoryFields,
  addCategoryField,
  updateCategoryField,
  deleteCategoryField,
} from "../../api";
import { getToken } from "../../utils/auth";

export default {
  name: "CategoryManage",
  data() {
    return {
      query: { categoryName: "" },
      list: [],
      loading: false,
      dialogVisible: false,
      isEdit: false,
      uploading: false,
      form: {
        id: null,
        categoryName: "",
        iconUrl: "",
        parentId: 0,
        sortOrder: 0,
        enabled: 1,
        showOnHome: 0,
      },
      rules: {
        categoryName: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
        ],
      },
      fieldVisible: false,
      fields: [],
      currentCategoryId: null,
      fieldDialogVisible: false,
      fieldIsEdit: false,
      fieldEditId: null,
      fieldForm: {
        categoryId: null,
        fieldName: "",
        fieldKey: "",
        fieldType: "TEXT",
        optionsJson: "",
        requiredFlag: 0,
        filterFlag: 0,
        listShowFlag: 0,
        detailShowFlag: 1,
        aiFieldFlag: 0,
        placeholder: "",
        defaultValue: "",
        sortOrder: 0,
        enabled: 1,
      },
      fieldRules: {
        fieldName: [{ required: true, message: "请输入字段名称", trigger: "blur" }],
        fieldKey: [{ required: true, message: "请输入字段Key", trigger: "blur" }],
        fieldType: [{ required: true, message: "请选择字段类型", trigger: "change" }],
      },
      fieldTypeOptions: [
        { label: "文本", value: "TEXT" },
        { label: "数字", value: "NUMBER" },
        { label: "单选", value: "RADIO" },
        { label: "多选", value: "CHECKBOX" },
        { label: "下拉", value: "SELECT" },
        { label: "图片", value: "IMAGE" },
        { label: "日期", value: "DATE" },
      ],
    };
  },
  computed: {
    uploadAction() {
      return process.env.VUE_APP_BASE_API
        ? process.env.VUE_APP_BASE_API + "/api/admin/files/upload"
        : "/api/admin/files/upload";
    },
    uploadHeaders() {
      return { access_token: getToken() };
    },
    filteredList() {
      if (!this.query.categoryName) return this.list;
      const keyword = this.query.categoryName.toLowerCase();
      const matchIds = new Set();
      // 找出所有名称匹配的分类及其所有祖先节点
      this.list.forEach((item) => {
        if (item.categoryName && item.categoryName.toLowerCase().includes(keyword)) {
          matchIds.add(item.id);
          // 向上追溯父节点
          let pid = item.parentId;
          while (pid && pid !== 0) {
            matchIds.add(pid);
            const parent = this.list.find((p) => p.id === pid);
            pid = parent ? parent.parentId : null;
          }
        }
      });
      return this.list.filter((item) => matchIds.has(item.id));
    },
    treeData() {
      return this.buildTree(this.filteredList, 0);
    },
  },
  created() {
    this.fetchList();
  },
  methods: {
    buildTree(list, parentId) {
      return list
        .filter((item) => item.parentId === parentId)
        .map((item) => {
          const children = this.buildTree(list, item.id);
          return children.length > 0 ? { ...item, children } : item;
        });
    },
    fetchList() {
      this.loading = true;
      getCategories()
        .then((res) => {
          // 后端消息转换器将Long转为String，统一转回数字；parentId为空时视为0(顶级)
          this.list = (res.data || []).map((item) => ({
            ...item,
            id: Number(item.id),
            parentId: Number(item.parentId || 0),
          }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    search() {
      // 前端过滤，无需请求后端
    },
    reset() {
      this.query.categoryName = "";
    },
    handleAdd() {
      this.isEdit = false;
      this.form = {
        id: null,
        categoryName: "",
        iconUrl: "",
        parentId: 0,
        sortOrder: 0,
        enabled: 1,
        showOnHome: 0,
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.form = { ...row };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
      this.dialogVisible = true;
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        this.$message.error("只能上传图片文件");
        return false;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("图标大小不能超过 2MB");
        return false;
      }
      this.uploading = true;
      return true;
    },
    handleUploadSuccess(res) {
      this.uploading = false;
      if (res.code === 200 && res.data && res.data.url) {
        this.form.iconUrl = res.data.url;
        this.$message.success("上传成功");
      } else {
        this.$message.error(res.msg || "上传失败");
      }
    },
    handleUploadError() {
      this.uploading = false;
      this.$message.error("上传失败，请重试");
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        // 构建干净请求体：过滤树结构带来的children等多余字段，null的parentId转为0
        const payload = {
          parentId: this.form.parentId || 0,
          categoryName: this.form.categoryName,
          categoryCode: this.form.categoryCode || '',
          iconUrl: this.form.iconUrl || '',
          description: this.form.description || '',
          cityCode: this.form.cityCode || '',
          aiEnabled: this.form.aiEnabled != null ? this.form.aiEnabled : 0,
          showOnHome: this.form.showOnHome != null ? this.form.showOnHome : 0,
          enabled: this.form.enabled != null ? this.form.enabled : 1,
          sortOrder: this.form.sortOrder != null ? this.form.sortOrder : 0,
        };
        const fn = this.isEdit
          ? updateCategory(this.form.id, payload)
          : addCategory(payload);
        fn.then(() => {
          this.$message.success(this.isEdit ? "修改成功" : "新增成功");
          this.dialogVisible = false;
          this.fetchList();
        });
      });
    },
    handleDelete(row) {
      this.$confirm("确定要删除该分类吗？", "提示", { type: "warning" })
        .then(() => {
          deleteCategory(row.id).then(() => {
            this.$message.success("删除成功");
            this.fetchList();
          }).catch(() => {});
        })
        .catch(() => {});
    },
    handleFields(row) {
      this.currentCategoryId = row.id;
      getCategoryFields({ categoryId: row.id }).then((res) => {
        this.fields = res.data || [];
        this.fieldVisible = true;
      });
    },
    handleAddField() {
      this.fieldIsEdit = false;
      this.fieldEditId = null;
      this.fieldForm = this.createDefaultFieldForm();
      this.fieldForm.categoryId = this.currentCategoryId;
      this.fieldDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.fieldFormRef) this.$refs.fieldFormRef.clearValidate();
      });
    },
    handleEditField(row) {
      this.fieldIsEdit = true;
      this.fieldEditId = row.id;
      this.fieldForm = {
        ...this.createDefaultFieldForm(),
        ...row,
        categoryId: this.currentCategoryId,
        requiredFlag: Number(row.requiredFlag || 0),
        filterFlag: Number(row.filterFlag || 0),
        listShowFlag: Number(row.listShowFlag || 0),
        detailShowFlag: Number(row.detailShowFlag != null ? row.detailShowFlag : 1),
        aiFieldFlag: Number(row.aiFieldFlag || 0),
        enabled: Number(row.enabled != null ? row.enabled : 1),
        sortOrder: Number(row.sortOrder || 0),
      };
      this.fieldDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.fieldFormRef) this.$refs.fieldFormRef.clearValidate();
      });
    },
    createDefaultFieldForm() {
      return {
        categoryId: null,
        fieldName: "",
        fieldKey: "",
        fieldType: "TEXT",
        optionsJson: "",
        requiredFlag: 0,
        filterFlag: 0,
        listShowFlag: 0,
        detailShowFlag: 1,
        aiFieldFlag: 0,
        placeholder: "",
        defaultValue: "",
        sortOrder: 0,
        enabled: 1,
      };
    },
    handleSubmitField() {
      this.$refs.fieldFormRef.validate((valid) => {
        if (!valid) return;
        const payload = {
          categoryId: this.currentCategoryId,
          fieldName: this.fieldForm.fieldName,
          fieldKey: this.fieldForm.fieldKey,
          fieldType: this.fieldForm.fieldType,
          optionsJson: this.fieldForm.optionsJson || "",
          requiredFlag: this.fieldForm.requiredFlag != null ? this.fieldForm.requiredFlag : 0,
          filterFlag: this.fieldForm.filterFlag != null ? this.fieldForm.filterFlag : 0,
          listShowFlag: this.fieldForm.listShowFlag != null ? this.fieldForm.listShowFlag : 0,
          detailShowFlag: this.fieldForm.detailShowFlag != null ? this.fieldForm.detailShowFlag : 1,
          aiFieldFlag: this.fieldForm.aiFieldFlag != null ? this.fieldForm.aiFieldFlag : 0,
          placeholder: this.fieldForm.placeholder || "",
          defaultValue: this.fieldForm.defaultValue || "",
          sortOrder: this.fieldForm.sortOrder != null ? this.fieldForm.sortOrder : 0,
          enabled: this.fieldForm.enabled != null ? this.fieldForm.enabled : 1,
        };
        const req = this.fieldIsEdit
          ? updateCategoryField(this.fieldEditId, payload)
          : addCategoryField(payload);
        req.then(() => {
          this.$message.success(this.fieldIsEdit ? "修改成功" : "新增成功");
          this.fieldDialogVisible = false;
          this.handleFields({ id: this.currentCategoryId });
        });
      });
    },
    handleDeleteField(row) {
      this.$confirm("确定要删除该字段吗？", "提示", { type: "warning" })
        .then(() => {
          deleteCategoryField(row.id).then(() => {
            this.$message.success("删除成功");
            this.handleFields({ id: this.currentCategoryId });
          });
        })
        .catch(() => {});
    },
  },
};
</script>
